import React, { useContext, useState } from 'react';
import { TemplateContext } from '../../../assets/js/TemplateContext';
import CreateTemplateStep0 from './CreateTemplate_0';
import CreateTemplateStep1 from './CreateTemplate_1';

const CreateTemplate = ({ onBack }) => {
  const { template } = useContext(TemplateContext);
  const [isSurveyCreated, setIsSurveyCreated] = useState(false);
  const [, setIsPreviewVisible] = useState(false);
  const [, setIsEditingQuestion] = useState(false);

  return isSurveyCreated ? (
    <CreateTemplateStep1
      diagnosticName={template.nombre}
      predefinedQuestions={template.preguntas}
      onPreviewChange={setIsPreviewVisible}
      onEditingQuestion={setIsEditingQuestion}
      onBack={() => setIsSurveyCreated(false)}
    />
  ) : (
    <CreateTemplateStep0
      onSurveyCreate={() => setIsSurveyCreated(true)}
      templateName={template.nombre}
      onBack={onBack}
    />
  );
};

export default CreateTemplate;
